import { render, staticRenderFns } from "./AdultContentWarning.vue?vue&type=template&id=036ffda2&scoped=true&"
import script from "./AdultContentWarning.vue?vue&type=script&lang=js&"
export * from "./AdultContentWarning.vue?vue&type=script&lang=js&"
import style0 from "./AdultContentWarning.vue?vue&type=style&index=0&id=036ffda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ffda2",
  null
  
)

export default component.exports